<template>
  <div class="row">
    <Card class="col-12 col-sm-12 col-md-6 col-lg-5 mx-auto">
      <AjaxForm v-if="category" :route="'admin/productCategory/delete/'+category._id" :callback="deleteCallback">
        <label class="d-block my-2">نوع حذف را انتخاب کنید : </label>
        <div class="form-check mb-2">
          <input class="form-check-input" type="radio" name="type" id="inlineRadio1" value="all">
          <label class="form-check-label" for="inlineRadio1">حذف دسته بندی و تمام زیردسته ها</label>
        </div>
        <div class="form-check mb-2">
          <input class="form-check-input" type="radio" name="type" id="inlineRadio2" value="one">
          <label class="form-check-label" for="inlineRadio2">حذف دسته بندی و انتقال زیردسته ها به دسته بالاتر</label>
        </div>
        <button type="submit" class="btn btn-block btn-danger my-2">تایید حذف</button>
      </AjaxForm>
      <div v-if="error" class="alert alert-danger">{{error}}</div>
    </Card>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti, showToast} from "@/shared/helper";

export default {
  name: "deleteCategory",
  components: {AjaxForm, Card},
  data()
  {
    return{
      category : null,
      error : null,
      id : this.$route.params.id,
    }
  },
  mounted()
  {
    this.setPageTitle('حذف دسته بندی محصول');
    this.setShowHead(true);
    this.setPageLoading(false);
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.id = this.$route.params.id;
      const result = await AppApi.getProductCategoryInfoForDelete(this.id);
      if (result.ok)
      {
        this.category = result.category;
        this.setPageTitle('حذف دسته بندی '+this.category.title);
      }
      else
        this.error = result.error;
      this.setPageLoading(false);
    },
    deleteCallback(data)
    {
      const self = this;
      if (data.ok)
      {
        showToast("success", data.message);
        setTimeout(function (){
          self.$router.go(-1);
        },2000);
      }
      else
        showSystemNoti('danger',data.error);
    }
  },

}
</script>

<style scoped>

</style>